import m from "../../es2015/lang/es_ES";
window.am4lang_es_ES = m;


//////////////////
// WEBPACK FOOTER
// ./lang/es_ES.js
// module id = null
// module chunks = 